/*缅怀*/
import {post} from '@/config/config.js'
import {urlpostfix,jsonpostfix} from '@/config/global.js'

/*export function getmhyldata(data){
  return post('api/theme/website/lingyuan/toCharData',data);
}*/
/*查询陵园地图数据接口*/
export function getmhyldata(data){
  return post(`${urlpostfix}api/theme/website/lingyuan/toCharData`,data);
}
/*查询晒一晒数据接口*/
export function getquerysysdata(data){
  return post(`${urlpostfix}api/theme/website/drying/list`,data);
}
/*添加晒一晒数据接口*/
export function getaddsysdata(data){
  return post(`${urlpostfix}api/theme/website/drying/insert`,data);
}
/*点亮陵园数据接口*/
export function getlightupdata(data){
  return post(`${urlpostfix}/api/theme/website/lingyuan/LightUp`,data);
}








// WEBPACK FOOTER //
// ./src/api/recollection.js